import { render, staticRenderFns } from "./PointDetailPanel.vue?vue&type=template&id=cf95b1f0&scoped=true"
import script from "./PointDetailPanel.vue?vue&type=script&lang=js"
export * from "./PointDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./PointDetailPanel.vue?vue&type=style&index=0&id=cf95b1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf95b1f0",
  null
  
)

export default component.exports